import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Menu,
  MenuItem,
  IconButton,
  Divider,
  Icon,
} from "@mui/material";
import React, { useContext, useState, useEffect } from "react";
import logo from "../assets/logo.png";
import { UserIcon } from "lucide-react";
import { useNavigate } from "react-router";
import { useUser } from "@/contexts/UserContext";
import { LogOutIcon } from "lucide-react";
const HeaderBtn = ({
  children,
  href,
}: {
  children: React.ReactNode;
  href: string;
}) => {
  const navigate = useNavigate();
  return (
    <Button
      color="primary"
      sx={{
        // fontWeight: 'bold',
        fontSize: "20px",
        textTransform: "none",
        fontFamily: "Roboto",
        fontStyle: "normal",
        lineHeight: "20px",
        color: "#0070C0",
        fontWeight: 500,
        padding: "8px 15px",
      }}
      onClick={() => {
        if (href.startsWith("http")) {
          // Điều hướng đến URL tuyệt đối
          window.location.href = href;
        } else if (href == "/") {
          window.location.href = "/";
        } else {
          navigate(href);
        }
      }}
    >
      {children}
    </Button>
  );
};

export default function EducatorRegisterHeader() {
  const { user } = useUser();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null); // Added state for dropdown
  // const [username, setUsername] = useState<string>('');

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    document.body.classList.remove("ro-popover-open");
    setAnchorEl(event.currentTarget); // Set anchor element for dropdown
  };

  const handleClose = () => {
    setAnchorEl(null); // Close dropdown
  };
  return (
    <>
      <AppBar
        position="static"
        color="transparent"
        sx={(theme) => ({
          zIndex: theme.zIndex.drawer + 1,
          boxShadow: "unset",
          padding: "10px",
          backgroundColor: "#fff",
        })}
      >
        <Toolbar
          sx={{
            ["& .MuiButtonBase-root"]: {
              fontFamily: "sans-serif",
              fontStyle: "normal",
              fontWeight: 500,
              fontSize: "20px",
              lineHeight: "22px",
              color: "#0070C0",
            },
          }}
        >
          <img
            src={logo}
            alt="logo"
            style={{
              width: "180px",
              marginRight: "10px",
              cursor: "pointer",
            }}
            onClick={() => (window.location.href = "/")}
          />

          <Box sx={{ flexGrow: 1 }} />
          <HeaderBtn href="/">Home</HeaderBtn>
          <HeaderBtn href={process.env.URL_SUPPORT!}>Support</HeaderBtn>
          <HeaderBtn href={process.env.URL_ABOUTUS!}>About Us</HeaderBtn>
          <HeaderBtn href={process.env.URL_COM!}>Community</HeaderBtn>

          {user?.user_login && (
            <>
              <Button
                size="small"
                variant="contained"
                onClick={handleClick}
                color="primary"
                title={user?.display_name}
                sx={{
                  textTransform: "none",
                  borderRadius: "30px",
                  ["& .MuiTypography-root"]: {
                    color: "white",
                  },
                  fontFamily: "Roboto",
                  fontStyle: "normal",
                  fontWeight: 700,
                  fontSize: "16px",
                  lineHeight: "19px",
                  textDecoration: "none",
                  color: "#F5F5F5",
                  marginLeft: "50px",
                }}
              >
                {/* <UserIcon /> */}

                <Typography variant="h6" noWrap component="div" ml={1}>
                  {user?.display_name}
                </Typography>
              </Button>

              <Menu
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                //   sx={{ display: { xs: 'block', md: 'none' } }}
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                <MenuItem onClick={() => window.location.reload()}>
                  <UserIcon size={20} />
                  <Typography variant="inherit" noWrap component="span" ml={1}>
                    Account
                  </Typography>
                </MenuItem>
                <Divider></Divider>
                <MenuItem
                  onClick={() =>
                    (window.location.href = user?.logout_url || "/")
                  }
                >
                  <LogOutIcon size={20} />
                  <Typography variant="inherit" noWrap component="span" ml={1}>
                    Logout
                  </Typography>
                </MenuItem>
              </Menu>
            </>
          )}
        </Toolbar>
      </AppBar>
    </>
  );
}
